import { Text } from '@mxenabled/mxui'

import Stack from '@mui/material/Stack'

interface CardFooterProps {
  accountName?: string
  actionButton?: React.ReactNode
  date?: string
}

const CardFooter = ({ accountName, actionButton, date }: CardFooterProps) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        px: 16,
        py: 8,
      }}
    >
      {date && <Text variant="tiny">{date}</Text>}
      {actionButton ?? (accountName && <Text variant="tiny">{accountName}</Text>)}
    </Stack>
  )
}

export default CardFooter
